"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.balanceOf = void 0;
var IERC20Factory_1 = require("../typings/IERC20Factory");
function balanceOf(user, tokenAddress) {
    var tokenContract = IERC20Factory_1.IERC20Factory.connect(tokenAddress, user);
    return tokenContract.balanceOf(user.address);
}
exports.balanceOf = balanceOf;
